import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Clipboard } from '../../../../shared/Clipboard';

export const WorkflowIdInfo = ({ workflowId }: { workflowId?: string }) => {
  if (!workflowId) return null;

  return (
    <Card.Body className="p-0 d-flex align-items-center gap-3 justify-content-end">
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="tooltip-id">{workflowId}</Tooltip>}
      >
        <div>
          <strong>Workflow ID: </strong>
          <small style={{ cursor: 'pointer' }}>
            {workflowId?.slice(0, 5)}...
          </small>
        </div>
      </OverlayTrigger>
      <Clipboard
        text={workflowId}
        toastMessage="Workflow ID copiado"
        dataTestId="copy-button"
      />
    </Card.Body>
  );
};
